import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/utils/i18n'
import { showLoading, hideLoading, showPageLoading, hidePageLoading } from '@/utils/loading'
import { showToast } from '@/utils/toast'
import { getCookie, getDomain } from '@/utils/cookie'
import '@/assets/styles/main.scss'
import '@/assets/styles/black-gold.css'
import siteCurrencyMixin from '@/mixins/siteCurrency'

Vue.config.productionTip = false
Vue.mixin(siteCurrencyMixin)

if (typeof document !== 'undefined') {
  document.title = ''
}

window.__APP_STORE__ = store

Vue.prototype.$loading = {
  show: showLoading,
  hide: hideLoading,
  showPage: showPageLoading,
  hidePage: hidePageLoading
}

Vue.prototype.$toast = showToast

const initialLoggedIn = !!getCookie(getDomain() + '-Token')
store.commit('SET_LOGGED_IN', initialLoggedIn)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
